import React, {Component} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import theme from "@irati/ui/src/global/theme"
import {Body} from "@irati/ui/src/Typography"
import IconText from "@irati/ui/src/IconText"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import id from "@irati/utils/id"
import ellipsis from "@irati/ui/src/global/css/multiLineEllipsis"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import getMyVote from "@irati/recognition/utils/polls/myVote"
import tooltipLimiter from "@irati/recognition/utils/tooltipLimiter"

import Tooltip, {Tip} from "../shared/Tooltip"

const TextContainer = styled(Body)`
  color: ${theme.colors.perkbox.blue};
  max-width: 185px;
  ${ellipsis(1)}
`

class WhoVoted extends Component {
  static propTypes = {
    poll: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    count: PropTypes.number,
    showMobileTooltip: PropTypes.bool
  }

  static defaultProps = {
    count: 2,
    id: "votedUsers",
    showMobileTooltip: false
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  getText = () => {
    const {poll} = this.props
    const myVote = getMyVote(poll)
    const voteCount = poll.votes.results.length

    if (!myVote) {
      return (
        <TextContainer small marginBottom={0.5}>
          <FormattedMessage id="recognition.whoVoted.toolTipText.notVoted" values={{voteCount}} />
        </TextContainer>
      )
    }

    return (
      <IconText icon="circleTick" color={theme.colors.perkbox.blue}>
        <TextContainer small>
          <FormattedMessage id="recognition.whoVoted.toolTipText.youVoted" values={{name: firstnameLastname(myVote.user)}} />
        </TextContainer>
      </IconText>
    )
  }

  getTooltip = () => {
    const {poll, count, intl} = this.props
    const users = tooltipLimiter(
      poll.votes.results.map((vote) => firstnameLastname(vote.createdBy)),
      intl
    )
    if (users.length <= count) {
      return null
    }

    return (
      <Tip id={id("tooltip", this.props)}>
        {users.map((user) => (
          <div key={user}>{user}</div>
        ))}
      </Tip>
    )
  }

  render() {
    const {showMobileTooltip} = this.props

    return (
      <Tooltip tip={this.getTooltip()} placement="bottom" showMobile={showMobileTooltip}>
        {this.getText()}
      </Tooltip>
    )
  }
}

export default injectIntl(WhoVoted)
